"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var d3 = tslib_1.__importStar(require("d3"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/fp/isEqual"));
var uniqueId_1 = tslib_1.__importDefault(require("lodash/fp/uniqueId"));
var Axis_1 = require("../Axis");
var ChartContainer_1 = require("../ChartContainer");
var chartUtils_1 = require("../chartUtils");
var MinMaxIndicator_1 = require("../MinMaxIndicator");
var LineChartUtils_1 = require("./LineChartUtils");
var Line_1 = require("../Line");
var ChartTooltip_1 = require("../ChartTooltip");
var LineChartTooltip_1 = require("../ChartTooltip/LineChartTooltip");
var utils_1 = require("../../utils");
var DEFAULT_ZOOM_FACTOR = 1.2;
var DEFAULT_MIN_ZOOM_RATIO = 1;
var DEFAULT_MAX_ZOOM_RATIO = 2;
var LineChart = (function (_super) {
    tslib_1.__extends(LineChart, _super);
    function LineChart(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseMove = function (_a) {
            var _b, _c;
            var event = _a.event, data = _a.data, xScale = _a.xScale, yScale = _a.yScale, xAxisType = _a.xAxisType;
            var pageX = event.pageX, pageY = event.pageY;
            var _d = _this.props, _e = _d.chartContainerType, chartContainerType = _e === void 0 ? 'OTHER' : _e, _f = _d.tooltipXOffset, tooltipXOffset = _f === void 0 ? 0 : _f, _g = _d.tooltipYOffset, tooltipYOffset = _g === void 0 ? 0 : _g;
            var _h = ChartTooltip_1.getMouseXYVal({
                chartOverlay: _this.ChartOverlay,
                pageX: pageX,
                pageY: pageY,
                xScale: xScale,
                yScale: yScale,
            }), mouseXVal = _h.mouseXVal, mouseYVal = _h.mouseYVal;
            var newTooltipXVal = ChartTooltip_1.getTooltipXVal(data, mouseXVal, xScale);
            var newTooltipData = LineChartTooltip_1.getLineChartTooltipDataType(data, newTooltipXVal, xScale);
            var xValMarkerText = newTooltipXVal !== undefined
                ? LineChartUtils_1.formatTooltipXAxisValue(xAxisType, newTooltipXVal)
                : '';
            var boundingRec = (_b = _this.ChartOverlay) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            var boundingRecWidth = (_c = boundingRec === null || boundingRec === void 0 ? void 0 : boundingRec.width) !== null && _c !== void 0 ? _c : 0;
            var tooltipIsWithinChartZoom = xScale(newTooltipXVal) <= boundingRecWidth;
            if (tooltipIsWithinChartZoom) {
                ChartTooltip_1.moveTooltipLine({
                    tooltipLine: _this.TooltipLine,
                    xLocation: xScale(newTooltipXVal),
                });
                LineChartUtils_1.moveTooltipCircles({
                    tooltipCircles: _this.TooltipCircles,
                    tooltipData: newTooltipData,
                    xScale: xScale,
                    yScale: yScale,
                });
                ChartTooltip_1.moveTooltipXAxisMarker({
                    tooltipXAxisMarker: _this.TooltipXAxisMarker,
                    tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
                    xScale: xScale,
                    xVal: newTooltipXVal,
                    markerText: xValMarkerText,
                });
                ChartTooltip_1.moveTooltip({
                    chartContainerType: chartContainerType,
                    chartOverlay: _this.ChartOverlay,
                    tooltip: _this.Tooltip,
                    absoluteTargetLocationX: xScale(newTooltipXVal),
                    absoluteTargetLocationY: yScale(mouseYVal),
                    tooltipXOffset: tooltipXOffset,
                    tooltipYOffset: tooltipYOffset,
                });
            }
            else {
                LineChartUtils_1.hideLineChartTooltipComponents({
                    tooltipCircles: _this.TooltipCircles,
                    useTransition: false,
                });
                ChartTooltip_1.hideTooltipComponents({
                    tooltipLine: _this.TooltipLine,
                    tooltip: _this.Tooltip,
                    tooltipXAxisMarker: _this.TooltipXAxisMarker,
                    tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
                    useTransition: false,
                });
            }
            _this.setState({ tooltipData: newTooltipData });
        };
        _this.onMouseLeave = function () {
            LineChartUtils_1.hideLineChartTooltipComponents({
                tooltipCircles: _this.TooltipCircles,
                useTransition: true,
            });
            ChartTooltip_1.hideTooltipComponents({
                tooltipLine: _this.TooltipLine,
                tooltip: _this.Tooltip,
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
                useTransition: true,
            });
        };
        _this.onMouseEnter = function () {
            ChartTooltip_1.showTooltipComponents({
                tooltipLine: _this.TooltipLine,
                tooltip: _this.Tooltip,
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
            });
        };
        _this.onMouseOverTooltip = function () {
            ChartTooltip_1.showTooltipComponents({
                tooltipLine: _this.TooltipLine,
                tooltip: _this.Tooltip,
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
            });
            LineChartUtils_1.showLineChartTooltipComponents({
                tooltipCircles: _this.TooltipCircles,
                useTransition: true,
            });
        };
        _this.onZoom = function () {
            var _a;
            ChartTooltip_1.hideTooltipComponents({
                tooltipLine: _this.TooltipLine,
                tooltip: _this.Tooltip,
                tooltipXAxisMarker: _this.TooltipXAxisMarker,
                tooltipXAxisMarkerText: _this.TooltipXAxisMarkerText,
                useTransition: false,
            });
            LineChartUtils_1.hideLineChartTooltipComponents({
                tooltipCircles: _this.TooltipCircles,
                useTransition: false,
            });
            var newZoomState = chartUtils_1.getNewZoomState(_this.SVGElement);
            var newZoomCursor = chartUtils_1.getNewZoomCursor((_a = d3.event.sourceEvent) === null || _a === void 0 ? void 0 : _a.type);
            _this.setState({ zoomState: newZoomState, zoomCursor: newZoomCursor });
        };
        _this.onZoomEnd = function () {
            _this.setState({ zoomCursor: 'grab' });
        };
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.onChartResize = _this.onChartResize.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
        _this.onClickLegendItem = _this.onClickLegendItem.bind(_this);
        _this.onMouseOverLegendItem = _this.onMouseOverLegendItem.bind(_this);
        _this.onMouseOutLegendItem = _this.onMouseOutLegendItem.bind(_this);
        _this.onMouseOverLegendItem = _this.onMouseOverLegendItem.bind(_this);
        _this.onClickDeselectAll = _this.onClickDeselectAll.bind(_this);
        _this.onClickSelectAll = _this.onClickSelectAll.bind(_this);
        _this.onZoom = _this.onZoom.bind(_this);
        _this.onZoomEnd = _this.onZoomEnd.bind(_this);
        _this.SVGElement = null;
        _this.LineChart = null;
        _this.ChartOverlay = null;
        _this.Tooltip = null;
        _this.TooltipLine = null;
        _this.TooltipCircles = null;
        _this.TooltipXAxisMarker = null;
        _this.TooltipXAxisMarkerText = null;
        var _a = _this.props, _b = _a.marginRight, marginRight = _b === void 0 ? 100 : _b, _c = _a.marginBottom, marginBottom = _c === void 0 ? 46 : _c;
        _this.chartMargin = {
            left: 0,
            right: marginRight,
            top: 0,
            bottom: marginBottom,
        };
        var dataWithSelection = props.data.map(function (d) { return (tslib_1.__assign(tslib_1.__assign({}, d), { isSelected: true })); });
        _this.state = {
            chartWidth: 0,
            chartHeight: 0,
            tooltipData: [],
            zoomState: null,
            zoomCursor: 'auto',
            selectableLegendData: dataWithSelection,
            selectedData: dataWithSelection,
            hoveredItemID: null,
        };
        _this.chartBreakPoints = {
            small: [570, 200],
            medium: [770, 400],
        };
        return _this;
    }
    LineChart.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    LineChart.getDerivedStateFromProps = function (props, state) {
        var data = props.data;
        var selectableLegendData = state.selectableLegendData;
        var dataWithoutSelection = selectableLegendData.map(function (_a) {
            var isSelected = _a.isSelected, rest = tslib_1.__rest(_a, ["isSelected"]);
            return (tslib_1.__assign({}, rest));
        });
        if (!isEqual_1.default(dataWithoutSelection, data)) {
            var dataWithSelection = data.map(function (d) { return (tslib_1.__assign(tslib_1.__assign({}, d), { isSelected: true })); });
            return {
                selectableLegendData: dataWithSelection,
                selectedData: dataWithSelection,
            };
        }
        return null;
    };
    LineChart.prototype.onClickLegendItem = function (clickedItem) {
        var selectableLegendData = this.state.selectableLegendData;
        var wasToggledOn = !clickedItem.isSelected;
        var newselectableLegendData = selectableLegendData.map(function (d) {
            if (d.ID === clickedItem.ID) {
                return tslib_1.__assign(tslib_1.__assign({}, d), { isSelected: wasToggledOn });
            }
            return d;
        });
        var newSelectedData = newselectableLegendData.filter(function (d) { return d.isSelected; });
        this.setState({
            selectableLegendData: newselectableLegendData,
            selectedData: newSelectedData,
        });
        if (!wasToggledOn) {
            this.setState({ hoveredItemID: null });
        }
    };
    LineChart.prototype.onMouseOverLegendItem = function (hoveredItem) {
        if (hoveredItem.isSelected) {
            this.setState({ hoveredItemID: hoveredItem.ID });
        }
    };
    LineChart.prototype.onMouseOutLegendItem = function () {
        this.setState({ hoveredItemID: null });
    };
    LineChart.prototype.onClickDeselectAll = function () {
        var selectableLegendData = this.state.selectableLegendData;
        var newselectableLegendData = selectableLegendData.map(function (d) {
            return tslib_1.__assign(tslib_1.__assign({}, d), { isSelected: false });
        });
        var newSelectedData = newselectableLegendData.filter(function (d) { return d.isSelected; });
        this.setState({
            selectableLegendData: newselectableLegendData,
            selectedData: newSelectedData,
        });
    };
    LineChart.prototype.onClickSelectAll = function () {
        var selectableLegendData = this.state.selectableLegendData;
        var newselectableLegendData = selectableLegendData.map(function (d) {
            return tslib_1.__assign(tslib_1.__assign({}, d), { isSelected: true });
        });
        var newSelectedData = newselectableLegendData.filter(function (d) { return d.isSelected; });
        this.setState({
            selectableLegendData: newselectableLegendData,
            selectedData: newSelectedData,
        });
    };
    LineChart.prototype.onChartResize = function (newWidth, newHeight) {
        var _a = this.state, chartWidth = _a.chartWidth, chartHeight = _a.chartHeight;
        var newWidthWithMargin = chartUtils_1.getChartWidthWithMargin(newWidth, this.chartMargin);
        var newHeightWithMargin = chartUtils_1.getChartHeightWithMargin(newHeight, this.chartMargin);
        if (!isEqual_1.default(newWidthWithMargin, chartWidth) ||
            !isEqual_1.default(newHeightWithMargin, chartHeight)) {
            this.setState({
                chartWidth: newWidthWithMargin,
                chartHeight: newHeightWithMargin,
            });
            this.createAttributes();
        }
    };
    LineChart.prototype.createAttributes = function () {
        var chartMargin = this.chartMargin;
        d3.select(this.LineChart).attr('transform', chartUtils_1.getChartTransformation(chartMargin));
    };
    LineChart.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, colorScale = _c.colorScale, yAxis = _c.yAxis, xAxis = _c.xAxis, chartContainerBreakpoints = _c.chartContainerBreakpoints, zoomable = _c.zoomable, _d = _c.minZoomRatio, minZoomRatio = _d === void 0 ? DEFAULT_MIN_ZOOM_RATIO : _d, _e = _c.maxZoomRatio, maxZoomRatio = _e === void 0 ? DEFAULT_MAX_ZOOM_RATIO : _e, _f = _c.zoomFactor, zoomFactor = _f === void 0 ? DEFAULT_ZOOM_FACTOR : _f;
        var _g = this.state, chartHeight = _g.chartHeight, chartWidth = _g.chartWidth, tooltipData = _g.tooltipData, zoomState = _g.zoomState, zoomCursor = _g.zoomCursor, selectableLegendData = _g.selectableLegendData, selectedData = _g.selectedData, hoveredItemID = _g.hoveredItemID;
        var _h = this, chartBreakPoints = _h.chartBreakPoints, chartMargin = _h.chartMargin;
        var axisLabelPadding = chartHeight <= chartBreakPoints.small[1] ? 12 : 16;
        var canZoom = zoomable;
        if (canZoom) {
            if (xAxis.tickValues) {
                canZoom = xAxis.tickValues.length > maxZoomRatio;
            }
        }
        var minY = d3.min(selectedData, function (d) { return d3.min(d.values, function (v) { return v.y; }); });
        var maxY = d3.max(selectedData, function (d) { return d3.max(d.values, function (v) { return v.y; }); });
        var minX = d3.min(selectedData, function (d) { return d3.min(d.values, function (v) { return v.x; }); });
        var maxX = d3.max(selectedData, function (d) { return d3.max(d.values, function (v) { return v.x; }); });
        var yAxisDomain = [minY, maxY];
        var xAxisDomain = xAxis.domain ? xAxis.domain : [minX, maxX];
        var yScale = chartUtils_1.getScaleByType(yAxis.type, yAxisDomain, [
            chartHeight - axisLabelPadding,
            axisLabelPadding,
        ]);
        var xScale = chartUtils_1.getScaleByType(xAxis.type, xAxisDomain, [
            0,
            chartWidth,
        ]);
        var zoomBehavior;
        var _j = chartUtils_1.getZoomButtonStateOnChartLoad(minZoomRatio, maxZoomRatio), disableReset = _j.disableReset, disableZoomIn = _j.disableZoomIn, disableZoomOut = _j.disableZoomOut;
        if (canZoom) {
            var extent = [
                [0, 0],
                [chartWidth, chartHeight],
            ];
            zoomBehavior = d3
                .zoom()
                .scaleExtent([minZoomRatio, maxZoomRatio])
                .translateExtent(extent)
                .extent(extent)
                .on('zoom', this.onZoom)
                .on('end', this.onZoomEnd);
            zoomBehavior(d3.select(this.SVGElement));
            d3.select(this.SVGElement).on('dblclick.zoom', function () {
                chartUtils_1.resetZoom(zoomBehavior, _this.SVGElement);
            });
        }
        if (zoomState) {
            var newScaleX = zoomState.rescaleX(xScale);
            xScale.domain(newScaleX.domain());
            var newYValues = LineChartUtils_1.getZoomMinMaxY(xScale, selectedData);
            minY = newYValues.minY;
            maxY = newYValues.maxY;
            yScale.domain([minY, maxY]);
            var zoomButtonState = chartUtils_1.getZoomButtonStateOnChartZoom(minZoomRatio, maxZoomRatio, zoomState);
            disableReset = zoomButtonState.disableReset;
            disableZoomIn = zoomButtonState.disableZoomIn;
            disableZoomOut = zoomButtonState.disableZoomOut;
        }
        var xAxisPrecision = (_a = xAxis.precision) !== null && _a !== void 0 ? _a : 2;
        var yAxisPrecision = (_b = yAxis.precision) !== null && _b !== void 0 ? _b : 2;
        var yAxisTickFormatWithPrecision = function (d) {
            return LineChartUtils_1.yAxisTickFormat(d, yAxisPrecision);
        };
        var xAxisTickFormat = LineChartUtils_1.getXAxisTickFormat(xAxis.type, chartWidth, chartBreakPoints, xAxis.tickValues ? xAxis.tickValues : xScale.ticks(), xAxisPrecision);
        var secondaryXAxisTickFormat = LineChartUtils_1.getSecondaryXAxisTickFormat(xAxis.type, chartWidth, chartBreakPoints, xAxis.tickValues ? xAxis.tickValues : xScale.ticks());
        var secondaryXAxisHeightOffset = 16;
        var minIndicatorValue = LineChartUtils_1.formatIndicatorValue(minY, yAxisPrecision);
        var maxIndicatorValue = LineChartUtils_1.formatIndicatorValue(maxY, yAxisPrecision);
        var yAxisTickValues;
        var xAxisTickValues;
        var showIndicators = chartHeight > chartBreakPoints.small[1];
        var tickNumber = chartHeight <= chartBreakPoints.medium[1] ? 4 : 6;
        if (chartHeight <= chartBreakPoints.small[1]) {
            yAxisTickValues = [minY, maxY];
        }
        if (chartWidth <= chartBreakPoints.small[0]) {
            xAxisTickValues = [minX, maxX];
        }
        else {
            xAxisTickValues = xAxis.tickValues || '';
        }
        var chartClipID = uniqueId_1.default('clip-path');
        var yAxisClipID = uniqueId_1.default('y-axis-clip-path');
        var hoveredData = selectedData.filter(function (d) { return d.ID === hoveredItemID; });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ChartContainer_1.ChartContainer, { onChartResize: this.onChartResize, tagsLegendColorScale: colorScale, tagsLegendData: selectableLegendData, breakpoints: chartContainerBreakpoints, zoomable: canZoom, onClickReset: function () {
                    return chartUtils_1.resetZoom(zoomBehavior, _this.SVGElement);
                }, onClickZoomIn: function () {
                    return chartUtils_1.onZoomInButtonClick(zoomBehavior, _this.SVGElement, zoomFactor);
                }, onClickZoomOut: function () {
                    return chartUtils_1.onZoomOutButtonClick(zoomBehavior, _this.SVGElement, zoomFactor);
                }, onClickLegendItem: this.onClickLegendItem, onMouseOverLegendItem: this.onMouseOverLegendItem, onMouseOutLegendItem: this.onMouseOutLegendItem, onClickDeselectAll: this.onClickDeselectAll, onClickSelectAll: this.onClickSelectAll, disableZoomIn: disableZoomIn, disableZoomOut: disableZoomOut, disableReset: disableReset, selectableLegend: true },
                react_1.default.createElement("svg", { width: chartUtils_1.getSVGWidth(chartWidth, chartMargin), height: chartUtils_1.getSVGHeight(chartHeight, chartMargin), ref: function (el) { return (_this.SVGElement = el); }, cursor: zoomState && zoomState.k <= 1 ? 'auto' : zoomCursor },
                    react_1.default.createElement("g", { ref: function (el) { return (_this.LineChart = el); }, width: chartWidth, height: chartHeight },
                        react_1.default.createElement(Axis_1.Axis, { width: chartWidth, height: chartHeight, orientation: "RIGHT", scale: yScale, displayLine: false, ticks: tickNumber, tickValues: yAxisTickValues, tickFormat: yAxisTickFormatWithPrecision, gridLines: "ZERO_ONLY", label: yAxis.label, unit: yAxis.unit, axisLabelPadding: axisLabelPadding, type: yAxis.type, maxAxisLabelWidth: chartHeight - axisLabelPadding }),
                        react_1.default.createElement(Axis_1.Axis, { width: chartWidth, height: chartHeight, orientation: "BOTTOM", scale: xScale, tickFormat: xAxisTickFormat, tickValues: xAxisTickValues, gridLines: "ALL", label: xAxis.label, axisExtension: this.chartMargin.right, tickLabelAnchor: "start", type: xAxis.type, "data-test-component-name": "line-chart-x-axis-primary" }),
                        secondaryXAxisTickFormat && (react_1.default.createElement(Axis_1.Axis, { width: chartWidth, height: chartHeight + secondaryXAxisHeightOffset, orientation: "BOTTOM", scale: xScale, tickFormat: secondaryXAxisTickFormat, tickValues: xAxisTickValues, displayLine: false, axisExtension: this.chartMargin.right, tickLabelAnchor: "start", type: xAxis.type, "data-test-component-name": "line-chart-x-axis-secondary" })),
                        showIndicators && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(MinMaxIndicator_1.MinMaxIndicator, { height: yScale(maxY), width: chartWidth, value: maxIndicatorValue, clipPath: "url(#" + yAxisClipID + ")" }),
                            react_1.default.createElement(MinMaxIndicator_1.MinMaxIndicator, { height: yScale(minY), width: chartWidth, value: minIndicatorValue, clipPath: "url(#" + yAxisClipID + ")" }))),
                        selectedData.map(function (d, i) {
                            return (d.ID !== hoveredItemID && (react_1.default.createElement(Line_1.Line, { key: i + "-line", color: !hoveredItemID
                                    ? colorScale(d, i)
                                    : utils_1.theme.colors.NTDarkGrey[100], yScale: yScale, xScale: xScale, data: d.values, clipPath: "url(#" + chartClipID + ")", strokeWidth: 1.5 })));
                        }),
                        hoveredData.map(function (d, i) { return (react_1.default.createElement(Line_1.Line, { key: i + "-line", color: colorScale(d, i), yScale: yScale, xScale: xScale, data: d.values, clipPath: "url(#" + chartClipID + ")", strokeWidth: 1.5 })); }),
                        react_1.default.createElement("clipPath", { id: chartClipID },
                            react_1.default.createElement("rect", { x: 0, y: 0, width: chartWidth, height: chartHeight })),
                        react_1.default.createElement("clipPath", { id: yAxisClipID },
                            react_1.default.createElement("rect", { x: 0, y: 0, width: chartWidth + chartMargin.right, height: chartHeight }))),
                    react_1.default.createElement(ChartTooltip_1.ChartTooltipLine, { ref: function (el) { return (_this.TooltipLine = el); }, chartHeight: chartHeight }),
                    react_1.default.createElement(ChartTooltip_1.ChartTooltipXAxisMarker, { ref: function (el) { return (_this.TooltipXAxisMarker = el); }, chartHeight: chartHeight }),
                    react_1.default.createElement(ChartTooltip_1.ChartTooltipXAxisMarkerText, { ref: function (el) { return (_this.TooltipXAxisMarkerText = el); }, chartHeight: chartHeight }),
                    react_1.default.createElement("g", { ref: function (el) { return (_this.TooltipCircles = el); }, clipPath: "url(#" + chartClipID + ")" }, selectedData.map(function (d, i) { return (react_1.default.createElement("circle", { key: i + "-tooltip-circle", fill: colorScale(d, i), r: 4, className: "tooltip-circle", opacity: 0 })); })),
                    react_1.default.createElement(ChartTooltip_1.ChartOverlay, { ref: function (el) { return (_this.ChartOverlay = el); }, chartWidth: chartWidth, chartHeight: chartHeight, onMouseLeave: this.onMouseLeave, onMouseEnter: this.onMouseEnter, onMouseMove: function (event) {
                            return _this.onMouseMove({
                                event: event,
                                data: selectedData,
                                xScale: xScale,
                                yScale: yScale,
                                xAxisType: xAxis.type,
                            });
                        } }))),
            react_1.default.createElement(ChartTooltip_1.ChartTooltip, { colorScale: colorScale, data: tooltipData, ref: function (el) { return (_this.Tooltip = el); }, onMouseEnter: this.onMouseOverTooltip, onMouseLeave: this.onMouseLeave, type: "LINE" })));
    };
    return LineChart;
}(react_1.PureComponent));
exports.LineChart = LineChart;
